var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.days.length>0)?_c('v-card',{attrs:{"flat":""}},[_vm._v(" disponnible "),_vm._l((_vm.days),function(item){return _c('v-chip',{key:item,staticClass:"mr-1 mt-1",attrs:{"label":""}},[_vm._v(_vm._s(_vm.list[item]))])})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }